
import './FloatingToolbar.css';

const FloatingToolbar = ({ onOpenFacetedSearch, activeFilterCount = 0 }) => {
  const handleExport = () => {
    console.log('Export data');
    // TODO: Implement export functionality
  };

  const handleRefresh = () => {
    console.log('Refresh dashboard');
    window.location.reload();
  };

  const handleCalendar = () => {
    console.log('Open date range picker');
    // TODO: Implement date range picker
  };

  const handleAnalytics = () => {
    console.log('Open analytics settings');
    // TODO: Implement analytics settings
  };

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <div className="floating-toolbar">
      {/* Main Dynamic Filters Button */}
      <button
        className="toolbar-btn toolbar-btn-primary"
        onClick={onOpenFacetedSearch}
        title="Open Dynamic Filters"
      >
        <svg className="toolbar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
        </svg>
        <span className="toolbar-text">Dynamic Filters</span>
        {activeFilterCount > 0 && (
          <span className="toolbar-badge">{activeFilterCount}</span>
        )}
      </button>

      <div className="toolbar-divider"></div>

      {/* Calendar/Date Range */}
      <button
        className="toolbar-btn toolbar-btn-icon"
        onClick={handleCalendar}
        title="Date Range"
      >
        <svg className="toolbar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
        </svg>
      </button>

      {/* Analytics/Insights */}
      <button
        className="toolbar-btn toolbar-btn-icon"
        onClick={handleAnalytics}
        title="Analytics Insights"
      >
        <svg className="toolbar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
        </svg>
      </button>

      {/* Refresh */}
      <button
        className="toolbar-btn toolbar-btn-icon"
        onClick={handleRefresh}
        title="Refresh Dashboard"
      >
        <svg className="toolbar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
        </svg>
      </button>

      {/* Export/Download */}
      <button
        className="toolbar-btn toolbar-btn-icon"
        onClick={handleExport}
        title="Export Data"
      >
        <svg className="toolbar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
        </svg>
      </button>

      {/* Fullscreen */}
      <button
        className="toolbar-btn toolbar-btn-icon"
        onClick={handleFullscreen}
        title="Toggle Fullscreen"
      >
        <svg className="toolbar-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"></path>
        </svg>
      </button>
    </div>
  );
};

export default FloatingToolbar;
